import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Annonsörer", -1)
const _hoisted_2 = { class: "row mt-3 mb-3" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" })
], -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "table table-sm table-striped table-bordered" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Företag"),
    /*#__PURE__*/_createElementVNode("th", null, "Kontakt"),
    /*#__PURE__*/_createElementVNode("th", null, "E-post"),
    /*#__PURE__*/_createElementVNode("th", null, "Kommentarer"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_12 = { class: "btn-group" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-edit" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-trash" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary btn-sm",
          to: "/mgmt/advertising/createadvertiser"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Lägg till annonsör")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm",
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args))),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.filter) = $event))
          }, null, 544), [
            [_vModelText, _ctx.state.filter]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAdvertisers, (advertiser) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: advertiser.advertiserId
              }, [
                _createElementVNode("td", null, _toDisplayString(advertiser.company), 1),
                _createElementVNode("td", null, _toDisplayString(advertiser.contact), 1),
                _createElementVNode("td", null, _toDisplayString(advertiser.email), 1),
                _createElementVNode("td", null, _toDisplayString(advertiser.comments), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.editAdvertiser(advertiser.advertiserId)),
                      class: "btn btn-sm btn-primary",
                      "data-toggle": "modal",
                      "data-target": "#advertisermodal",
                      title: "Ändra annonsör"
                    }, _hoisted_15, 8, _hoisted_13),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.deleteAdvertiser(advertiser)),
                      class: "btn btn-sm btn-danger",
                      title: "Ta bort annonsör"
                    }, _hoisted_18, 8, _hoisted_16)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}